export default "__VITE_ASSET__R9Sz098g__"